import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';
import { get_form_url } from '@/tools/form';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100 mt-20">
      <div className="px-4 md:px-6 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-book-read-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold font-heading text-background-50">
                  韩国漫画大全
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                {siteInfo.description.slice(0, 80)}……
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <div className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="space-y-2">
                <Link to="/" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/category/all" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  全部分类
                </Link>
                <Link to="/category/all?status=completed" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  完结漫画
                </Link>
                <Link to="/category/all?sort=newest" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  最新更新
                </Link>
                <Link to="/about" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <p className="text-sm text-foreground-300 mb-2">
                <i className="ri-mail-line mr-2"></i>
                {siteInfo.contactEmail}
              </p>
              <p className="text-sm text-foreground-300 mb-4">
                <i className="ri-map-pin-line mr-2"></i>
                {siteInfo.address}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-background-100 hover:bg-accent-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-background-100 hover:bg-accent-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-background-100 hover:bg-accent-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} {siteInfo.name} All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              收录 {siteInfo.totalComics.toLocaleString()}+ 部韩漫作品 · 每日更新 · 免费阅读
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}